import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { useAuth } from '@/shared/auth/AuthProvider';

export interface RouterContext {
  auth: ReturnType<typeof useAuth>;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
});
